import React from 'react'
import { Link } from 'react-router-dom'
import { FaFish } from 'react-icons/fa'

function CookiePolicy() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Simple Navbar */}
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center space-x-2">
              <FaFish className="h-8 w-8 text-blue-600" />
              <span className="font-bold text-xl text-gray-900">AnglersAI</span>
            </Link>
          </div>
        </div>
      </nav>
      
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <Link to="/" className="text-blue-600 hover:text-blue-800 mb-8 inline-block">
          ← Back to Home
        </Link>
        
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Cookie Policy</h1>
        
        <div className="bg-white rounded-lg shadow-lg p-8 space-y-6">
          <section>
            <p className="text-gray-600 mb-6">
              Last updated: {new Date().toLocaleDateString()}
            </p>
            
            <p className="text-gray-700 mb-6">
              This Cookie Policy explains how Wright Media, LLC ("we," "us," or "our") uses cookies and similar 
              technologies to recognize you when you visit our website at anglersai.com ("Website") and use our 
              AnglersAI mobile application ("App"). It explains what these technologies are and why we use them, 
              as well as your rights to control our use of them.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">What are cookies?</h2>
            <p className="text-gray-700 mb-4">
              Cookies are small data files that are placed on your computer or mobile device when you visit a 
              website. Cookies are widely used by website owners in order to make their websites work, or to 
              work more efficiently, as well as to provide reporting information.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Why do we use cookies?</h2>
            <p className="text-gray-700 mb-4">
              We use first-party and third-party cookies for several reasons. Some cookies are required for 
              technical reasons in order for our Website to operate, and we refer to these as "essential" or 
              "strictly necessary" cookies. Other cookies enable us to track and target the interests of our 
              users to enhance the experience on our Website. Third parties serve cookies through our Website 
              for analytics and other purposes.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Types of cookies we use</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Essential website cookies</h3>
            <p className="text-gray-700 mb-4">
              These cookies are strictly necessary to provide you with services available through our Website 
              and to use some of its features, such as access to secure areas.
            </p>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Analytics and customization cookies</h3>
            <p className="text-gray-700 mb-4">
              These cookies collect information that is used either in aggregate form to help us understand 
              how our Website is being used or how effective our marketing campaigns are, or to help us 
              customize our Website for you.
            </p>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Performance cookies</h3>
            <p className="text-gray-700 mb-4">
              We use these cookies to enhance the performance and functionality of our Website but are 
              non-essential to their use. However, without these cookies, certain functionality may become 
              unavailable.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Cookies used on our Website</h2>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border border-gray-200">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="px-4 py-2 border-b text-left">Cookie Name</th>
                    <th className="px-4 py-2 border-b text-left">Purpose</th>
                    <th className="px-4 py-2 border-b text-left">Duration</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="px-4 py-2 border-b">__cf_bm</td>
                    <td className="px-4 py-2 border-b">Cloudflare bot management</td>
                    <td className="px-4 py-2 border-b">30 minutes</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 border-b">_ga</td>
                    <td className="px-4 py-2 border-b">Google Analytics tracking</td>
                    <td className="px-4 py-2 border-b">2 years</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 border-b">_gid</td>
                    <td className="px-4 py-2 border-b">Google Analytics tracking</td>
                    <td className="px-4 py-2 border-b">24 hours</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Mobile App</h2>
            <p className="text-gray-700 mb-4">
              Our mobile application does not use cookies. However, we may collect certain information 
              automatically, including, but not limited to, the type of mobile device you use, your mobile 
              device's unique device ID, the IP address of your mobile device, your mobile operating system, 
              and information about the way you use the App.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">How can I control cookies?</h2>
            <p className="text-gray-700 mb-4">
              You have the right to decide whether to accept or reject cookies. You can exercise your cookie 
              rights by setting your preferences in the Cookie Consent Manager. The Cookie Consent Manager 
              allows you to select which categories of cookies you accept or reject. Essential cookies cannot 
              be rejected as they are strictly necessary to provide you with services.
            </p>
            <p className="text-gray-700 mb-4">
              You can also set or amend your web browser controls to accept or refuse cookies. If you choose 
              to reject cookies, you may still use our website though your access to some functionality and 
              areas of our website may be restricted.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Browser-specific controls</h2>
            <p className="text-gray-700 mb-4">
              Most web browsers allow some control of most cookies through the browser settings. To find out 
              more about cookies, including how to see what cookies have been set, visit:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li><a href="https://www.aboutcookies.org" className="text-blue-600 hover:text-blue-800">www.aboutcookies.org</a></li>
              <li><a href="https://www.allaboutcookies.org" className="text-blue-600 hover:text-blue-800">www.allaboutcookies.org</a></li>
            </ul>
            
            <p className="text-gray-700 mb-4">
              To opt out of being tracked by Google Analytics across all websites, visit:
            </p>
            <p className="mb-4">
              <a href="http://tools.google.com/dlpage/gaoptout" className="text-blue-600 hover:text-blue-800">
                http://tools.google.com/dlpage/gaoptout
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Do Not Track</h2>
            <p className="text-gray-700 mb-4">
              Some browsers include a Do Not Track ("DNT") feature that signals to websites that you do not 
              want to have your online activity tracked. Currently, our Website does not respond to browser 
              DNT signals.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Updates to this Cookie Policy</h2>
            <p className="text-gray-700 mb-4">
              We may update this Cookie Policy from time to time in order to reflect, for example, changes to 
              the cookies we use or for other operational, legal or regulatory reasons. Please therefore re-visit 
              this Cookie Policy regularly to stay informed about our use of cookies and related technologies.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact us</h2>
            <p className="text-gray-700 mb-4">
              If you have any questions about our use of cookies or other technologies, please contact us at:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>Email: support@wrightmedia.com</li>
              <li>Website: anglersai.com</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  )
}

export default CookiePolicy